import { render, staticRenderFns } from "./menupopout-top.vue?vue&type=template&id=1b83a86d"
import script from "./menupopout-top.vue?vue&type=script&lang=js"
export * from "./menupopout-top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports